// src/components/ErrorPage.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ErrorPage.css';

const ErrorPage = () => {
  const navigate = useNavigate();

  return (
    <div className="error-container">
      <div className="error-content">
        <div className="error-code">404</div>
        <div className="error-message">Page Not Found</div>
        <div className="error-description">
          The page you are looking for might have been unavailable.
        </div>
        <button onClick={() => navigate(-1)} className="home-button">Go Back</button>
      </div>
    </div>
  );
};

export default ErrorPage;
